var _circle, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPowerBtn = function SvgPowerBtn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.9999,
    cy: 23,
    r: 22.4359,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1333 9C22.176 9 21.4 9.77604 21.4 10.7333V15.9333C21.4 16.8906 22.176 17.6667 23.1333 17.6667C24.0906 17.6667 24.8667 16.8906 24.8667 15.9333V10.7333C24.8667 9.77604 24.0906 9 23.1333 9ZM19.4299 12.9915C18.9502 12.1631 17.8898 11.8803 17.0614 12.36C13.3411 14.5139 11 18.4873 11 22.8667C11 29.5677 16.4323 35 23.1333 35C29.8344 35 35.2667 29.5677 35.2667 22.8667C35.2667 18.5048 32.9443 14.545 29.2478 12.3847C28.4213 11.9017 27.3597 12.1801 26.8767 13.0066C26.3937 13.8331 26.6721 14.8947 27.4986 15.3777C30.1421 16.9226 31.8 19.7495 31.8 22.8667C31.8 27.6531 27.9198 31.5333 23.1333 31.5333C18.3469 31.5333 14.4667 27.6531 14.4667 22.8667C14.4667 19.737 16.138 16.9004 18.7984 15.3601C19.6268 14.8804 19.9096 13.82 19.4299 12.9915Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 60.5171,
    y1: 14.5539,
    x2: 15.6453,
    y2: -15.6088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A1F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3984DD"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPowerBtn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/power_btn.f7c61483.svg";
export { ForwardRef as ReactComponent };